<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Vigneti Robert Mondovì</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Cacciato dall'azienda di famiglia dopo una vera e propria scazzottata con il fratello, Robert Mondovì aveva 53 anni quando creò la sua omonima azienda vinicola. Cinque decenni dopo, è salutato come l'uomo che ha rivoluzionato le cantine della Napa Valley, se non del tutto l'industria vinicola americana. La grandezza, a quanto pare, può arrivare a qualsiasi età.
                    </div>

                    <div class="howto-title2">Fued di famiglia</div>
                    <div class="howto-text">
                        Nato nel 1913 in Minnesota da genitori immigrati italiani, il padre di Robert vi si recava regolarmente
                        la costa occidentale per acquistare uva per la comunità italiana della costa orientale. Un trasferimento di famiglia,
                        una laurea alla Stanford University e una chiacchierata persuasiva con suo padre per acquistare la defunta 1861 St.
                        Helena in seguito, e nasce la cantina Mondovì. Tuttavia, avanti veloce 23 anni e
                        le differenze familiari hanno avuto la meglio su di loro, con l'ormai famosa scazzottata che ha portato a una divisione
                        della famiglia e Robert che va per la sua strada (è interessante notare che i figli di Robert, Michael e Tim
                        soffrono le stesse differenze creative del padre e dello zio). Testardo e riluttante a farlo
                        compromesso, Robert ha creato le cantine Robert Mondovi nel 1966 a Oakville, Napa Valley, cambiando
                        il volto delle aziende vinicole della Napa Valley per sempre.
                    </div>

                    <div class="howto-title2">Un inizio stellare</div>
                    <div class="howto-text">
                        La prima annata dello Chenin Blanc di Mondovì del 1967 è stata lanciata sul mercato entusiasta a $ 2 a bottiglia
                        - la stessa bottiglia oggi (se riesci a trovarla) ti costerebbe qualcosa nella regione di € 350.
                        Arruolando l'aiuto dei talenti emergenti della regione (Warren Winiarski, fondatore Stag&#39;s
                        Leap Wine Cellars, Mike Grgich e Zelma Long che sono tutti nella Winemaker's Hall of Fame),
                        Mondovì si è sforzata di produrre vini di qualità e si è concentrata sulla qualità piuttosto che sulla quantità. Il suo
                        primo vigneto, To Kolon (623 acri, piantato nel 1861) fu oggetto di un'aspra causa con il suo
                        famiglia con la sentenza del giudice che Robert dovrebbe tenere i due terzi. Oggi, vino di questo vigneto
                        è una delle sue 19 cuvée più costose e poco disponibili.
                    </div>

                    <div class="howto-title2">Opus Uno</div>
                    <div class="howto-text">
                        Le cantine Robert Mondavi sono state vendute a Constellation Drinks nel 2004, con il gigante delle bevande che ha guadagnato
                        controllo di tutto tranne il 50% del vigneto Opus One, joint venture tra Mondavi e
                        Barone di Rothschild. Questo vino vede una buona performance di mercato (negli USA) e rappresenta il
                        la maggior parte degli investimenti nel settore vitivinicolo e del commercio di vini della regione. Tuttavia, il vino divide
                        critici e la sua popolarità sul mercato secondario non sempre trova riscontro tra gli esperti.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Robert Mondovi Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Robert Mondovi wurde nach einem echten Faustkampf mit seinem Bruder aus dem Familienunternehmen geworfen und war 53 Jahre alt, als er sein gleichnamiges Weingut gründete. Fünf Jahrzehnte später wird er als der Mann gefeiert, der die Weingüter im Napa Valley, wenn nicht sogar die gesamte amerikanische Weinindustrie, revolutioniert hat. Größe, so scheint es, kann in jedem Alter kommen.
                    </div>

                    <div class="howto-title2">Familienleben</div>
                    <div class="howto-text">
                        Roberts Vater wurde 1913 als Sohn italienischer Einwanderer in Minnesota geboren und reiste regelmäßig dorthin
                        der Westküste, um Trauben für die italienische Gemeinde an der Ostküste zu kaufen. Ein Familienumzug,
                        einen Abschluss an der Stanford University und ein überzeugendes Gespräch mit seinem Vater, um das nicht mehr existierende 1861 St. zu kaufen.
                        Später wurde das Weingut Helena gegründet und das Weingut Mondovi gegründet. Allerdings 23 Jahre später
                        Die familiären Differenzen überwältigten sie, und der inzwischen berühmte Faustkampf führte zu einer Spaltung
                        der Familie und Robert, der seinen eigenen Weg geht (interessanterweise Roberts eigene Söhne Michael und Tim).
                        leiden unter den gleichen kreativen Unterschieden wie ihr Vater und ihr Onkel). Eigensinnig und unwillig
                        Als Kompromiss gründete Robert 1966 die Weingüter Robert Mondovi in Oakville, Napa Valley
                        wird für immer das Gesicht der Weingüter im Napa Valley sein.
                    </div>

                    <div class="howto-title2">Ein hervorragender Start</div>
                    <div class="howto-text">
                        Der erste Jahrgang von Mondovis 1967er Chenin Blanc wurde für 2 Dollar pro Flasche auf den Markt gebracht
                        - Die gleiche Flasche würde Sie heute (sofern Sie sie finden) etwa 350 € kosten.
                        Die Hilfe der aufstrebenden Talente der Region gewinnen (Warren Winiarski, Gründer von Stag&#39;s
                        Leap Wine Cellars, Mike Grgich und Zelma Long, die alle in der Winemaker’s Hall of Fame sind),
                        Mondovi strebte danach, Premiumweine zu produzieren und konzentrierte sich eher auf Qualität als auf Quantität. Sein
                        Der erste Weinberg, To Kolon (623 Acres, gepflanzt 1861), war Gegenstand eines erbitterten Rechtsstreits mit ihm
                        Familie, wobei der Richter entschied, dass Robert zwei Drittel behalten sollte. Heute Wein aus diesem Weinberg
                        gehört zu den teuersten und am seltensten erhältlichen seiner 19 Cuvées.
                    </div>

                    <div class="howto-title2">Opus Eins</div>
                    <div class="howto-text">
                        Robert Mondavi Wineries wurden 2004 an Constellation Drinks verkauft, wobei der Getränkegigant zulegte
                        Kontrolle über alles bis auf 50 % des Opus One-Weinbergs, einem Joint Venture zwischen Mondavi und
                        Baron de Rothschild. Dieser Wein verzeichnet eine gute Marktleistung (in den USA) und trägt dazu bei
                        Mehrheit der Weininvestitionen und des Handels mit Weinen der Region. Allerdings spaltet sich der Wein
                        Kritiker und seine Beliebtheit auf dem Sekundärmarkt spiegeln sich nicht immer bei den Experten wider.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vignobles Robert Mondovi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Expulsé de l'entreprise familiale après une véritable bagarre avec son frère, Robert Mondovi a 53 ans lorsqu'il crée son domaine éponyme. Cinq décennies plus tard, il est salué comme l'homme qui a révolutionné les vignobles de Napa Valley, sinon l'industrie vinicole américaine. La grandeur, semble-t-il, peut venir à tout âge.
                    </div>

                    <div class="howto-title2">Relations familiales</div>
                    <div class="howto-text">
                        Né en 1913 dans le Minnesota de parents immigrés italiens, le père de Robert voyageait régulièrement à
                        la côte ouest pour acheter du raisin pour la communauté italienne de la côte est. Un déménagement familial,
                        un diplôme de l'Université de Stanford et une conversation persuasive avec son père pour acheter le défunt 1861 St.
                        La cave Helena plus tard, et la cave Mondovi a été créée. Cependant, avance rapide de 23 ans et
                        les différences familiales ont eu raison d'eux, avec la désormais célèbre bagarre entraînant une division
                        de la famille et Robert suit son propre chemin (il est intéressant de noter que les propres fils de Robert, Michael et Tim
                        souffrent des mêmes différences créatives que leur père et leur oncle). Têtu et peu disposé à
                        compromis, Robert a créé les vignobles Robert Mondovi en 1966 à Oakville, Napa Valley, changeant
                        le visage des vignobles de Napa Valley pour toujours.
                    </div>

                    <div class="howto-title2">Un début stellaire</div>
                    <div class="howto-text">
                        Le premier millésime du Chenin Blanc 1967 de Mondovi a été lancé sur le marché avide à 2 $ la bouteille
                        - la même bouteille aujourd'hui (si vous pouvez la trouver) vous coûterait environ 350 €.
                        Solliciter l'aide des talents émergents de la région (Warren Winiarski, fondateur Stag&#39;s
                        Leap Wine Cellars, Mike Grgich et Zelma Long qui sont tous dans le Winemaker's Hall of Fame),
                        Mondovi s'est efforcé de produire des vins haut de gamme et s'est concentré sur la qualité plutôt que sur la quantité. Son
                        premier vignoble, To Kolon (623 acres, planté en 1861) fit l'objet d'un âpre procès avec son
                        famille avec le juge décidant que Robert devait garder les deux tiers. Aujourd'hui, le vin de ce vignoble
                        est l'une des plus chères et des plus rares de ses 19 cuvées.
                    </div>

                    <div class="howto-title2">Opus One</div>
                    <div class="howto-text">
                        Robert Mondavi Wineries a été vendu à Constellation Drinks en 2004, le géant des boissons gagnant
                        contrôle de tout sauf 50% du vignoble d'Opus One, joint-venture entre Mondavi et
                        Baron de Rothschild. Ce vin réalise de bonnes performances sur le marché (aux USA) et représente la
                        majorité des investissements viticoles et du négoce des vins de la région. Cependant, le vin se divise
                        critiques et sa popularité sur le marché secondaire ne se reflète pas toujours parmi les experts.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Robert Mondovi Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Kicked out of the family business after an actual fistfight with his brother, Robert Mondovi was 53 when he created his eponymous winery. Five decades later and he is hailed as the man who revolutionised Napa Valley wineries, if not America’s wine industry altogether. Greatness, it seems, can come at any age.
                    </div>

                    <div class="howto-title2">Family fueds</div>
                    <div class="howto-text">
                        Born in 1913 in Minnesota to Italian immigrant parents, Robert’s father travelled regularly to
                        the west coast to buy grapes for the Italian community on the east coast. One family relocation,
                        a Stanford University degree and a persuasive chat with his dad to buy the defunct 1861 St.
                        Helena winery later, and the Mondovi winery was created. However, fast forward 23 years and
                        family differences got the better of them, with the now-famous fistfight resulting in a division
                        of the family and Robert going his own way (interestingly Robert’s own sons Michael and Tim
                        suffer the same creative differences as their father and uncle). Headstrong and unwilling to
                        compromise, Robert created Robert Mondovi wineries in 1966 in Oakville, Napa Valley, changing
                        the face of Napa Valley wineries forever.
                    </div>

                    <div class="howto-title2">A stellar start</div>
                    <div class="howto-text">
                        The first vintage of Mondovi’s 1967 Chenin Blanc was released to the eager market at $2 a bottle
                        - the same bottle today (if you can find it) would cost you something in the region of €350.
                        Enlisting the help of the up and coming talent of the region (Warren Winiarski, founder Stag&#39;s
                        Leap Wine Cellars, Mike Grgich and Zelma Long who are all in the Winemaker’s Hall of Fame),
                        Mondovi strove to produce premium wines and focused on the quality rather than quantity. His
                        first vineyard, To Kolon (623-acres, planted in 1861) was subject to a bitter lawsuit with his
                        family with the judge ruling that Robert should keep two-thirds. Today, wine from this vineyard
                        is some of the most expensive an scarcely available of his 19 cuvees.
                    </div>

                    <div class="howto-title2">Opus One</div>
                    <div class="howto-text">
                        Robert Mondavi Wineries were sold to Constellation Drinks in 2004, with the drinks giant gaining
                        control of everything bar 50% of the Opus One vineyard, a joint venture between Mondavi and
                        Baron de Rothschild. This wine sees good market performance (in the USA) and accounts for the
                        majority of wine investments and trading for wines of the region. However, the wine divides
                        critics and its popularity on the secondary market is not always mirrored among the experts.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RobertMondoviVineyards",
    head: {
        title: 'Robert Mondovi Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unparalleled taste of Robert Mondovi Vineyards, a Napa Valley-based winery that produces premium, handcrafted wines using only the finest grapes.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
